import type { FC } from 'react'
import { ClockInOutDetailsBase } from 'screens/Rostering/components/ClockInOutDetailBase'
import type { ClockInOutAction } from 'screens/Rostering/hooks/useClockInOut'
import type {
  ClockInLocation,
  GeolocationStatus
} from 'screens/Rostering/types'

type ClockOutDetailsProps = {
  time?: string
  note?: string
  location?: ClockInLocation
  openClockInOutModal: () => void
  warnings?: string[]
  action: ClockInOutAction
  isDeletedSU?: boolean
  timezone?: string
  publishedRota?: boolean
  showInvalidAddressForGeofencingWarning?: boolean
  clockOutGeolocationStatus?: GeolocationStatus
}

export const ClockOutDetails: FC<ClockOutDetailsProps> = (props) => (
  <ClockInOutDetailsBase
    {...props}
    type="out"
    geolocationStatus={props.clockOutGeolocationStatus}
  />
)
